import { reactive, computed } from "@nuxtjs/composition-api";
const state = reactive({
  isQuoteCartSidebarOpen: false,
  isQuoteRequestModalOpen: false
});
function useQuoteCartState() {
  const toggleQuoteCartSidebar = () => {
    state.isQuoteCartSidebarOpen = !state.isQuoteCartSidebarOpen;
  };
  const openQuoteRequestModal = () => {
    state.isQuoteRequestModalOpen = true;
  };
  const closeQuoteRequestModal = () => {
    state.isQuoteRequestModalOpen = false;
  };
  return {
    isQuoteCartSidebarOpen: computed(() => state.isQuoteCartSidebarOpen),
    isQuoteRequestModalOpen: computed(() => state.isQuoteRequestModalOpen),
    toggleQuoteCartSidebar,
    openQuoteRequestModal,
    closeQuoteRequestModal
  };
}
export {
  useQuoteCartState
};
